// @flow

import React from "react";

import { LoginLink } from "../components/login-link";

import { Validation } from "../model/validation";

import { Recover } from "../components/recover/index";
import { ServiceManager } from "../service/service-manager";

type Props = {
    serviceManager: ServiceManager
};

type States = {
    email: string,
    validation: Validation,
    serverValidateFail: boolean,
    serverValidateMsg: ?string,
    resetting: boolean,
    resetted: boolean,
    submitButtonText: string
};

export class RecoverContainer extends React.Component<Props, States> {
    state: States;
    constructor(props: Props) {
        super(props);
        this.state = {
            email: "",
            resetting: false,
            resetted: false,
            submitButtonText: "Continue",
            serverValidateFail: false,
            serverValidateMsg: null,
            validation: {
                success: "",
                required: false,
                format: false
            }
        };
    }

    onEmailChanged = (e: Event, email: string) => {
        const validation = this.props.serviceManager.validationService.validateForRecover(
            email
        );
        this.setState({ email, validation });
    };

    resetPassword = async (e: Event) => {
        e.preventDefault();
        if (this.validate()) {
            const promiseRecover = this.props.serviceManager.loginService.recover(
                this.state.email
            );
            this.setState({ resetting: true });
            try {
                await promiseRecover;
                this.setState({ resetted: true });
            } catch (e) {
                this.setState({
                    serverValidateFail: true,
                    serverValidateMsg: e.errorMessage
                });
            } finally {
                this.setState({ resetting: false });
            }
        }
    };
    validate = () => {
        const validation = this.props.serviceManager.validationService.validateForRecover(
            this.state.email
        );
        this.setState({
            validation,
            serverValidateFail: false,
            serverValidateMsg: null
        });
        return validation.success === "success";
    };

    shouldDisableSubmit = () => {
        if (this.state.validation.success === "fail") {
            return true;
        }
        if (this.state.resetting === true) {
            return true;
        }
        return false;
    };

    render = () => {
        return (
            <div className="login-page__section-login">
                <h1 className="login-page__section-login-header">
                    Forgotten Password
                </h1>
                <hr />
                <div className="form-intro">
                    Simply enter your email address below to regain access to
                    your account.
                </div>
                <div className="form-wrapper login-page__section-login-form">
                    <Recover
                        email={this.state.email}
                        validation={this.state.validation}
                        serverValidateFail={this.state.serverValidateFail}
                        serverValidateMsg={this.state.serverValidateMsg}
                        resetted={this.state.resetted}
                        status={this.state.resetting ? "loading" : ""}
                        disabledSubmit={this.shouldDisableSubmit()}
                        submitButtonText={this.state.submitButtonText}
                        onEmailChanged={this.onEmailChanged}
                        onSubmit={this.resetPassword}
                    />
                    <LoginLink id="backtosignin">Back to signin</LoginLink>
                </div>
            </div>
        );
    };
}
